/** @jsx jsx */

import React, { useCallback } from "react";
import { Typography } from "antd";
import { useHistory } from "react-router-dom";
import { jsx } from "@emotion/core";

import Button from "../../components/button";
import useEligibilityDetails from "../../hooks/eligibility/useEligibilityDetails";
import useEligibilityMetaData from "../../hooks/auth/useEligibilityMetaData";
import useNameAndImage from "../../hooks/profile/useNameAndImage";

import { routes, EligibilityRoutes } from "../../Routes";
import { EligibilityGetstartedStyles } from "./EligibilityGetstartedStyles";
import { EligibilityGetstartedContents as CONSTANTS } from "./EligibilityGetstartedConstants";

const { Title, Text } = Typography;

const EligibilityGetstarted: React.FC = () => {
  const { initializeEligibilityId } = useEligibilityDetails();
  const {
    eligibilityMetaData: { loading }
  } = useEligibilityMetaData();
  const history = useHistory();
  const redirectTo = useCallback((route: string) => history.replace(route), [
    history
  ]);
  const redirect = () => {
    redirectTo(routes.eligibility.view(EligibilityRoutes.CompanyFold));
  };

  const { userName } = useNameAndImage();

  const renderEligibilityGetstarted = (
    <div
      css={EligibilityGetstartedStyles}
      className="d-flex flex-column justify-content-center align-items-center"
    >
      <Title level={2} className="greeting">
        {CONSTANTS.labels.greeting(userName)}
      </Title>
      <Text className="note mt-2 mb-4">
        {CONSTANTS.labels.initiateEligibility}
      </Text>
      <Button
        containerDivClassName="mt-3"
        type="primary"
        loading={loading}
        onClick={() => initializeEligibilityId(redirect)}
      >
        {CONSTANTS.buttons.getStarted}
      </Button>
    </div>
  );
  return renderEligibilityGetstarted;
};

export default EligibilityGetstarted;
